import "./style.less";

// 段落
const Paragraph = {
  name: "HtmlParagraph",
  render() {
    const { $slots } = this;
    return <p class="s-e-paragraph">{$slots.default}</p>;
  }
};
// 文本
const Text = {
  name: "HtmlText",
  render() {
    const { $slots } = this;
    return <span class="s-e-text">{$slots.default}</span>;
  }
};
// 图片
const Img = {
  name: "HtmlImg",
  porps: {
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    }
  },
  render() {
    const { src, alt } = this;
    return <img class="s-e-image" src={src} alt={alt} />;
  }
};
// 超链接
const Link = {
  name: "HtmlLink",
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    rel: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  render() {
    const { href, target, rel, title, $slots } = this;
    return (
      <a href={href} target={target} rel={rel} title={title}>
        {$slots.default}
      </a>
    );
  }
};
// 操作按钮
const Button = {
  name: "HtmlButton",
  props: {
    btnKey: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    data: {
      type: [String, Object, Array],
      default: ""
    }
  },
  render() {
    const { btnKey, id, data, $slots } = this;
    return (
      <button
        class="s-e-button"
        data-button-id={id}
        onClick={() => this.$emit("buttonExec", btnKey, id, data)}
      >
        {$slots.default}
      </button>
    );
  }
};

export default {
  name: "WikiReanderHtml",
  components: {},
  props: {
    editorData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    handleButtonExec(key, id, data) {
      console.log(key, id, data);
      this.$emit("onButtonExec", key, id, data);
    }
  },
  render() {
    // 渲染文本样式
    const renderStyleText = data => {
      let vnode = data.text || "\uFEFF";
      if (data.bold) {
        vnode = <strong>{vnode}</strong>;
      }
      if (data.italic) {
        vnode = <em>{vnode}</em>;
      }
      if (data.underline) {
        vnode = <u>{vnode}</u>;
      }
      if (data.through) {
        vnode = <s>{vnode}</s>;
      }
      return vnode;
    };

    const renderText = data => {
      return data.children.map((item, index) => {
        if (item.type === "image") {
          return (
            <Img key={index} src={item.src} alt={item.alt} style={item.style} />
          );
        }
        if (item.type === "link") {
          return (
            <Link
              key={index}
              href={item.url}
              target={item.target || "_blank"}
              rel={item.rel}
              title={item.title}
            >
              {renderText(item)}
            </Link>
          );
        }
        if (item.type === "button") {
          return (
            <Button
              key={index}
              btn-key={item.key}
              id={item.id}
              data={item.data}
              onButtonExec={this.handleButtonExec}
            >
              {renderText(item)}
            </Button>
          );
        }
        return (
          <Text
            key={index}
            style={{
              color: item.color,
              backgroundColor: item.bgColor,
              fontSize: item.fontSize
            }}
          >
            {renderStyleText(item)}
          </Text>
        );
      });
    };
    return (
      <div class="editor-content">
        {this.editorData.map((item, index) => {
          return (
            <Paragraph
              key={index}
              style={{
                lineHeight: item.lineHeight
              }}
            >
              {renderText(item)}
            </Paragraph>
          );
        })}
        
        {this.$slots.default}
      </div>
    );
  }
};
